<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2020</p>
<p class="center ">Copyright © 2019 by Bill Pennington</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="https://www.hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<div class="timebreak "> </div>
<p class="center "><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Names: Pennington, Bill, 1956– author.</p>
<p class="center ">Title: Chumps to champs : how the worst teams in Yankees history led to the 90’s dynasty / Bill Pennington.</p>
<p class="center ">Description: Boston : Houghton Mifflin Harcourt, [2019] | Includes bibliographical references and index.</p>
<p class="center ">Identifiers: LCCN 2018046434 (print) | LCCN 2018051095 (ebook) | ISBN 9781328849878 (ebook) | ISBN 9781328849854 (hardback) | ISBN 9780358331834 (pbk.)</p>
<p class="center ">Subjects: LCSH: New York Yankees (Baseball team)—History—20th century. | Baseball players—New York (State)—New York—Biography. | Baseball managers—New York (State)—New York—Biography. | BISAC: SPORTS &amp; RECREATION / Baseball / History. | HISTORY / United States / State &amp; Local / Middle Atlantic (DC, DE, MD, NJ, NY, PA).</p>
<p class="center ">Classification: LCC GV875.N4 (ebook) | LCC GV875.N4 P45 2019 (print) | DDC 796.357/64097471—dc23</p>
<p class="center ">LC record available at <a href="https://lccn.loc.gov/2018046434" target="_blank">https://lccn.loc.gov/2018046434</a></p>
<div class="timebreak "> </div>
<p class="center ">Cover design by Mark R. Robinson</p>
<p class="center ">Cover photograph (top) © Douglas C. Pizac / Associated Press; (bottom) © Linda Cataffo / <em>New York Daily News</em> Archive</p>
<p class="center ">Author photograph © Nina Subin</p>
<div class="timebreak "> </div>
<p class="center ">v2.0320</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?32a9a0b4